import React from "react";
import "./Content.scss";
import EngagedSection from "./EngagedSection";
import ParallaxPhoto from "./ParallaxPhoto";
import Schedule from "./Schedule";
import Transport from "./Transport";
import Counter from "./Counter";
import ConfirmationContainer from "./ConfirmationContainer";
import Godparents from "./Godparents";

function Content() {
  return (
    <div className="relative content-custom-margin">
      <EngagedSection />
      <ParallaxPhoto photoClass="parallax-engaged">
        <h1 id="schedule" className="text-white text-center">
          ПРОГРАМА
        </h1>
      </ParallaxPhoto>
      <Schedule />
      <Transport />
      <Godparents />
      <Counter />
      {/* <ParallaxPhoto photoClass="parallax-our-story">
        <br />
        <h1 id="history" className="text-white text-center">
          И КОЙ КАЗА?
        </h1>
        <br />
      </ParallaxPhoto> */}
      <ConfirmationContainer />

      <div className="p-top-12 p-top-4-xs bg-base p-bottom-6 text-center">
        <h5>с обич:</h5>
        <h3>Мария и Красимир</h3>
        <div className="heart m-auto"></div>
        <div className="container m-auto flex p-top-12 p-top-8-xs">
          <hr className="flex flex-justify-center col-12-xs col-12-sm col-8 hr-style m-top-2 m-bottom-2 m-left-auto m-right-auto" />
        </div>
        <div>Copyright ©2025 Сватбена покана</div>
        <div>
          Автор: Булката
          <i className="m-left-1 fa-solid fa-hand-holding-heart"></i>
        </div>
      </div>
    </div>
  );
}

export default Content;
